import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { httpActions } from '..';
import { REQUEST, ROUTES } from '../../consts';
import { IAppState } from '../../types/state.d';
import { apiThunk, appThunk } from '.';
import { getTeamStatus } from '../../selectors/apiSelectors';
import { ITeamSettingsFormProps } from '../../containers/TeamSettings/TeamSettings.d';
import { saveTeamSettingsData } from '../actionCreators/appActions';

const updateTeamSettings = (data: ITeamSettingsFormProps) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
) => {
  const resourceName = REQUEST.UPDATE_TEAM_SETTINGS;
  try {
    const teamStatus = getTeamStatus(getState());

    dispatch(saveTeamSettingsData(data));

    dispatch(httpActions.httpRequestMade(resourceName));

    await dispatch(apiThunk.updateFundraisingData());
    await dispatch(apiThunk.updateTeamMembersTarget(data.teamMembersTarget));

    if (teamStatus !== 'active') {
      await dispatch(apiThunk.updateShortName());
      await dispatch(apiThunk.activatePage());
    }

    dispatch(httpActions.httpRequestSuccess(resourceName));
    dispatch(appThunk.pushToPage(ROUTES.YOUR_TEAM_PAGE));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
  }
};

export default updateTeamSettings;
